<template>
  <div class="responsible-info" >

    <div class="responsible-info-header">
      <v-container>
        <ResponsibleInfos :name="responsibleInfos.name" :document="responsibleInfos.document" :picture="responsibleInfos.picture"/>
      </v-container>
    </div>

    <div class="responsible-info-content container pt-0">
      <StudentList class="card-student-list" :students="students"/>
    </div>

    <div class="responsible-info-action">
      <div class="container pt-0">
        <v-btn block @click="openConfirm" :disabled="!isAppOnline || !selectedStudents.length" data-test="release-button">Liberar</v-btn>
      </div>

      <DialogConfirm :visibility="dialogConfirmVisibility" :title="dialogTitle">

        <template slot="within-list">
          <template v-for="(student, index) in selectedStudents">
            <StudentListRow :student="student" :key="index" />
          </template>
        </template>

        <template slot="left-side-action">
          <v-btn icon dark @click="hideConfirm">
            <v-icon>close</v-icon>
          </v-btn>
        </template>

        <template slot="bottom-action">
          <v-btn block @click="confirmStudents" data-test="confirm-button" :disabled="!isAppOnline">Confirmar</v-btn>
        </template>

      </DialogConfirm>
    </div>
  </div>
</template>

<script>
import ResponsibleInfos from '@/components/ResponsibleInfos'
import StudentList from '@/components/StudentList'
import StudentListRow from '@/components/StudentList/StudentListRow'
import DialogConfirm from '@/components/DialogConfirm'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  components: {
    ResponsibleInfos,
    StudentList,
    StudentListRow,
    DialogConfirm
  },

  data: () => ({
    dialogConfirmVisibility: false,
    dialogTitle: 'Confirmação'
  }),

  computed: {
    ...mapState({
      responsibleInfos: state => state.responsibleInfos.data,
      students: state => state.responsibleInfos.students,
      isAppOnline: state => state.network.online
    }),
    selectedStudents () {
      return this.getSelectedStudents()
    },
    studentsRequestData () {
      return this.getStudentsRequestData()
    }
  },

  methods: {
    ...mapActions({
      fecthResponsibleInfos: 'responsibleInfos/fetchResponsibleInfos',
      sendStudents: 'responsibleInfos/sendStudents'
    }),

    ...mapGetters({
      getSelectedStudents: 'responsibleInfos/getSelectedStudents',
      getStudentsRequestData: 'responsibleInfos/getStudentsRequestData'
    }),

    hideConfirm () {
      this.dialogConfirmVisibility = false
    },

    openConfirm () {
      this.dialogConfirmVisibility = true
    },

    confirmStudents () {
      this.sendStudents(this.studentsRequestData)
      this.hideConfirm()
    }
  }
}
</script>

<style lang="stylus" scoped>
  .card-student-list
    flex 1 0 0
    display flex

  .responsible-info
    height 100%
    display flex
    flex-direction column
    &-header
      overflow hidden
    &-content
      display flex
      flex-direction column
      flex 1 0 0
      overflow hidden
    &-action
      height 50px
      overflow hidden
</style>
